// A signed-out visit to a challenge link is sent to sign-in by the router,
// which does not remember where the visit was going. The link's path waits on
// the device for 30 minutes; the 챌린지 tab takes it when a signed-in member
// arrives. Only a challenge page's path, or a page of the new 챌린지 program
// (/today and below), is ever kept or followed.
const KEY = 'yp:ch:return';
const TTL = 30 * 60 * 1000;
const PAGE = /^\/challenges(?:-next)?\/([A-Za-z0-9]{20})\/?$/;
// /today, /today/daily/<id>, /today/vault/expr/<id>…: plain segments only, never a query, a dot or an address
const TODAY = /^\/today((?:\/[A-Za-z0-9_-]{1,64}){0,4})\/?$/;

/** '/challenges/<id>' for a challenge page's path (under either name of the route), '/today…' for a program page's, '' for anything else. */
export const returnPath = (path) => {
  const s = typeof path === 'string' ? path : '';
  const m = PAGE.exec(s);
  if (m) return `/challenges/${m[1]}`;
  const t = TODAY.exec(s);
  return t ? `/today${t[1]}` : '';
};

export function keepReturn(path, now = Date.now(), store) {
  const p = returnPath(path);
  if (!p) return;
  try { (store || window.localStorage).setItem(KEY, JSON.stringify({ p, t: now })); } catch (e) { /* storage is off: the visit goes on as it always did */ }
}

/** The kept path if it is still good. Whatever was there is cleared. */
export function takeReturn(now = Date.now(), store) {
  try {
    const s = store || window.localStorage, raw = s.getItem(KEY);
    if (raw === null) return '';
    s.removeItem(KEY);
    const v = JSON.parse(raw), p = returnPath(v && v.p);
    return p && p === v.p && typeof v.t === 'number' && now >= v.t && now - v.t < TTL ? p : '';
  } catch (e) { return ''; }
}

/**
 * Called once at start, before the router redirects: a visitor on a challenge
 * (or /today) link who turns out to be signed out. Reads auth and changes nothing in it.
 */
export function keepSignedOutVisit(auth, loc = window.location) {
  const path = loc.pathname;
  if (!returnPath(path)) return;
  let asked = false;
  auth.onAuthStateChanged((user) => {
    if (asked) return;
    asked = true;
    if (!user) keepReturn(path);
  });
}
